import { FC, useCallback, useMemo } from 'react'
import { Modal } from '../../components'
import { useTranslation } from 'react-i18next'
import { IdoorAccess } from '../../API/types'
import dayjs from 'dayjs'
import { DATETIME_FORMAT } from '../../API/utils'

interface DoorAccessDeleteProps {
  handleClickClose: () => void
  handleDeleteDoorAccess: (id: string) => void
  roomsListData: IdoorAccess[]
  id: string
}

const DoorAccessDelete: FC<DoorAccessDeleteProps> = ({
  handleClickClose,
  handleDeleteDoorAccess,
  roomsListData,
  id,
}) => {
  const { t } = useTranslation('')

  const roomsData = useMemo(() => {
    return roomsListData.find((roomsData) => roomsData.id === id)
  }, [id, roomsListData])

  const handleClose = useCallback(() => {
    handleClickClose()
  }, [handleClickClose])

  const handleAccept = useCallback(async () => {
    handleDeleteDoorAccess(id)
    handleClickClose()
  }, [handleClickClose, handleDeleteDoorAccess, id])

  return (
    <Modal
      maxWidth={'sm'}
      isOpen={true}
      handleClose={handleClose}
      handleAccept={handleAccept}
      dialogTitle={t(
        `Dzēst pieeju - ${dayjs(roomsData?.dateFrom).format(DATETIME_FORMAT)} - ${dayjs(roomsData?.dateTo).format(
          DATETIME_FORMAT,
        )}`,
      )}
      acceptTitle={t(`Dzēst`)}
      closeTitle={t(`Atcelt`)}
    >
      {roomsData?.comments}
    </Modal>
  )
}

export default DoorAccessDelete
